import React, { useState, useRef, useEffect } from "react";
import "./ProductView.css";
import axiosConfig from "../../Service/axiosConfig";
import { NavLink, useNavigate } from "react-router-dom";
import Slider from "react-slick";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { SingleProduct } from "./SingleProduct";
function SampleNextArrow(props) {
  const { className, style, onClick, insideCart } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        right: insideCart ? "-10px" : "-20px",
        zIndex: 2,
        background: "#fff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        borderRadius: "50%",
        width: "34px",
        height: "34px",
      }}
      onClick={onClick}
    >
      <MdChevronRight size={24} color="#333" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick, insideCart } = props;
  return (
    <div
      className={className}
      style={{
        ...style,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        left: "-20px",
        zIndex: 2,
        background: "#fff",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        borderRadius: "50%",
        width: "34px",
        height: "34px",
      }}
      onClick={onClick}
    >
      <MdChevronLeft size={24} color="#333" />
    </div>
  );
}

const ProductView = (props) => {
  console.log("fetch product", props);
  const { insideCart } = props;
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [Data, SetData] = useState([]);
  let sliderRef = useRef(null);
  const next = () => {
    sliderRef.slickNext();
  };
  const previous = () => {
    sliderRef.slickPrev();
  };
  const GetData = async (props) => {
    setLoading(true);
    try {
      console.log(props.filter_id);
      let storeId = localStorage.getItem("storeId");
      let url = `/catlog/products/?subcategory=${props.filter_id}&page_size=7&is_suspended=false`;
      if (storeId && storeId !== "null") {
        url += `&store=${storeId}`;
      }
      const responce = await axiosConfig.get(url);
      console.log(responce, "res...");
      SetData(responce.data.results);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const GetSimilarProducts = async (id) => {
    try {
      const orderId = localStorage.getItem("orderId");
      const response = await axiosConfig.get(
        `/catlog/get_similar_products/?product_id=${id}&order_id=${
          orderId ? orderId : ""
        }`
      );
      let similar_products = response.data.map((item) => {
        return item.product;
      });
      console.log(response.data, "similar...");
      SetData(similar_products);
    } catch (error) {
      console.log("Error getting similar products : ", error);
    }
  };
  useEffect(() => {
    if (props.id) {
      GetSimilarProducts(props.id);
    } else if (props.filter_id) {
      GetData(props);
    } else {
      SetData([]);
      setLoading(false);
    }
  }, [props.id, props.filter_id]);
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: insideCart ? 2 : 3,
    slidesToScroll: insideCart ? 2 : 1,
    nextArrow: <SampleNextArrow insideCart={insideCart} />,
    prevArrow: <SamplePrevArrow insideCart={insideCart} />,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          slidesToShow: insideCart ? 2 : 3,
          slidesToScroll: insideCart ? 2 : 1,
        },
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: insideCart ? 2 : 3,
          slidesToScroll: insideCart ? 2 : 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: insideCart ? 2 : 2,
          slidesToScroll: insideCart ? 2 : 1,
        },
      },
      {
        breakpoint: 766,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="products-container">
        {loading ? (
          <div className="loader-container">
            <img
              src={require("../FormParser/images/loader.gif")}
              alt="Loading..."
            />
          </div>
        ) : (
          <>
            {Data.length > 0 ? (
              <div className="container">
                <div className="d-flex justify-content-between">
                  <h2>{props.products_for}</h2>
                  <div className="d-flex align-items-center">
                    {props.product_slug && (
                      <span className="view-all">View More</span>
                    )}
                  </div>
                </div>
                <div className="slider-container">
                  {Data.length >= 6 ? (
                    <Slider
                      ref={(slider) => {
                        sliderRef = slider;
                      }}
                      {...settings}
                    >
                      {Data.map((itemObj, index) => {
                        return (
                          <SingleProduct
                            item={itemObj}
                            index={index}
                            LoginAccount={props.LoginAccount}
                            Setlogin={props.Setlogin}
                          />
                        );
                      })}
                    </Slider>
                  ) : Data.length > 2 && insideCart ? (
                    <Slider
                      ref={(slider) => {
                        sliderRef = slider;
                      }}
                      {...settings}
                    >
                      {Data.map((itemObj, index) => {
                        return (
                          <SingleProduct
                            item={itemObj}
                            index={index}
                            LoginAccount={props.LoginAccount}
                            Setlogin={props.Setlogin}
                          />
                        );
                      })}
                    </Slider>
                  ) : (
                    <div className={`grid_${Data.length >= 6 ? "6" : "5"}`}>
                      {Data.map((itemObj, index) => {
                        return (
                          <div style={{ marginRight: "3%" }} key={index}>
                            <SingleProduct item={itemObj} index={index} />
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div className="container">
                <div className="d-flex justify-content-between">
                  <h2>{props.products_for || "Products Section"}</h2>
                </div>
                <div className="placeholder-products-row">
                  {[1, 2, 3, 4, 5].map((_, index) => (
                    <div key={index} className="placeholder-product-card">
                      <div className="placeholder-product-img-wrapper">
                        <div className="placeholder-product-img"></div>
                      </div>
                      <div className="placeholder-product-name-line1"></div>
                      <div className="placeholder-product-name-line2"></div>
                      <div className="placeholder-product-price"></div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};
export { ProductView };
